import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="bg-white shadow-md w-full p-4 mt-8">
            <div className="container mx-auto flex flex-col justify-center items-center text-center text-gray-600">
                <div>
                    <a href="https://www.limbachgruppe.com/datenschutz/" className="hover:underline mx-2">Term of Service</a>
                    <span className="mx-2">|</span>
                    <a href="https://www.limbachgruppe.com/datenschutz/" className="hover:underline mx-2">Privacy Policy</a>
                </div>
                <div className="mt-2">
                    <span>© 2025 planyvo.com</span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
